/**
 * Search-index normalisation, kept strictly separate from displayed text
 * (spec: "The normalised search index is separate from displayed original
 * text"). Never write this back over fullName/shortCode/etc.
 */
const COMBINING_DIACRITICS = /[̀-ͯ]/g;

export function normalizeForSearch(...parts: (string | null | undefined)[]): string {
  return parts
    .filter((p): p is string => !!p && p.length > 0)
    .join(' ')
    .normalize('NFKD')
    .replace(COMBINING_DIACRITICS, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}
